import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { useAccountAppContext } from '@/app/AccountAppContext'

export const useTotpMfa = () => {
    const { t } = useTranslation()

    const queryClient = useQueryClient()

    const { api, accountKey, showSuccess, showError, clearSuccess } = useAccountAppContext()

    const start = useMutation({
        mutationFn: () => api.setupTotp(),
        retry: false,
        onSuccess: () => {
            clearSuccess()
        },
        onError: (error) => {
            showError(error instanceof Error ? error.message : t('messages.totpStartError'))
        },
    })

    const verify = useMutation({
        mutationFn: (code: string) => api.verifyTotp({ code }),
        retry: false,
        onSuccess: async () => {
            showSuccess(t('messages.totpEnabled'))
            await queryClient.invalidateQueries({ queryKey: ['account', accountKey, 'security'] })
        },
    })

    const remove = useMutation({
        mutationFn: () => api.removeTotp(),
        retry: false,
        onSuccess: async () => {
            showSuccess(t('messages.totpRemoved'))
            await queryClient.invalidateQueries({ queryKey: ['account', accountKey, 'security'] })
        },
        onError: (error) => {
            showError(error instanceof Error ? error.message : t('messages.totpRemoveError'))
        },
    })

    return { start, verify, remove }
}
